module.exports = __webpack_public_path__ + "static/media/fishsite.69e819ee.jpg";